function getHiddenEmail(mail) {
	var arrobaPosition = mail.indexOf('@')
	var cleanMail = mail.substring(0, arrobaPosition)
	var cleanCharsQuantity = Math.round(cleanMail.length / 4)
	var asterisks = '*'.repeat(cleanMail.substring(cleanCharsQuantity).length)
	var response =
		cleanMail.substring(0, cleanCharsQuantity) +
		asterisks +
		mail.substring(arrobaPosition)

	return response
}

export { getHiddenEmail }
